import React, { useState } from 'react';
import { FaCheck, FaTimes } from 'react-icons/fa'; // Icons for check and X

const InfoSection = ({ title }) => {
    const [removeClicked, setRemoveClicked] = useState(false); // Track if Remove was clicked
    const [inputValue, setInputValue] = useState(''); // Track input value for the text box

    const sectionStyle = {
        display: 'inline-block',
        width: '80%',  // Increased width for wider sections
        padding: '20px',
        border: '1px solid rgba(0, 0, 0, .125)',
        borderRadius: '5px',
        position: 'relative',
        textAlign: 'center',
        backgroundColor: '#fff',
        marginBottom: '20px',  // Space between rows
    };

    const inputStyle = {
        width: '100%',
        padding: '12px',
        borderRadius: '4px',
        border: '1px solid rgba(0, 0, 0, 0.1)',
        fontSize: '14px',
    };

    const buttonWrapperStyle = {
        position: 'absolute',
        top: '-10px',
        right: '-50px', // Keep the original position for the "Remove" button
        display: 'flex',
        gap: '5px',   // Add space between buttons when they appear
    };

    const buttonStyle = {
        padding: '6px 12px',
        border: 'none',
        borderRadius: '4px',
        fontSize: '12px',
        cursor: 'pointer',
        fontWeight: 'bold',
    };

    const removeButtonStyle = {
        ...buttonStyle,
        backgroundColor: '#dc3545',
        color: 'white',
        position: 'absolute', // Original position of remove button
        top: '-10px',
        right: '-10px',
    };

    const confirmButtonStyle = {
        ...buttonStyle,
        backgroundColor: '#198754',
        color: 'white',
    };

    const cancelButtonStyle = {
        ...buttonStyle,
        backgroundColor: '#dc3545',
        color: 'white',
    };

    const handleRemoveClick = () => {
        setRemoveClicked(true);
    };

    const handleCancelRemove = () => {
        setRemoveClicked(false); // Reset state if cancel
    };

    const handleDelete = () => {
        // Logic for deleting the info section goes here
        // console.log(`Deleted ${title}`);
    };

    return (
        <div style={sectionStyle}>
            <input
                type="text"
                placeholder={title}
                style={inputStyle}
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
            />
            {!removeClicked ? (
                <button style={removeButtonStyle} onClick={handleRemoveClick}>
                    Remove
                </button>
            ) : (
                <div style={buttonWrapperStyle}>
                    <button style={confirmButtonStyle} onClick={handleCancelRemove}>
                        <FaCheck />
                    </button>
                    <button style={cancelButtonStyle} onClick={handleDelete}>
                        <FaTimes />
                    </button>
                </div>
            )}
        </div>
    );
};

export default InfoSection;
